import { render } from "./node-gradient.svg?vue&type=template&id=c8361642"
const script = {}

import exportComponent from "/Users/colin/Documents/FUSE/code/live/fusestudio.net/Graphite/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__